<template>
  <div class="aside-float-warp">
    <ul class="aside-float">
      <li class="tel" ><div class="tel-img"></div>
        电话咨询</li>
      <li @click="showMeiqia('courseCost')">课程费用</li>
      <li @click="showMeiqia('classTimetable')">上课时间</li>
      <li @click="showMeiqia('howToAppoint')">如何预约</li>
      <li @click="showMeiqia('teacherArrangement')">师资安排</li>
    </ul>
  </div>
</template>

<script>
import "../../../common/third-js-file.js"
import {saTrack} from '@xes/dh-sensor';

export default {
  name: "asidefloat",
  data(){
    return {
    }
  },
  mounted() {
    this.initMeiqia();
  },
  methods: {
    showMeiqia(event) {
      saTrack(event);
      if (typeof window._MEIQIA !== 'undefined') {
        // 美洽强制打开窗口
        if (window._MEIQIA._isAllset) {
           window._MEIQIA('showPanel');
          window._MEIQIA._showPanelByForced = true;
        }
        return;
      }
    },
    initMeiqia() {
      // 美洽初始化成功
      let _this = this;
      window._MEIQIA('withoutBtn');
      window._MEIQIA('allSet', function () {
        // 初始化完毕
        window._MEIQIA._isAllset = true;
        _this.isInitMeiqia = true;
        // 初始化美洽窗口样式
        document.getElementsByName('button')[0].style.zIndex = 10;
      });
    }
  }
};
</script>
<style lang="scss">
.aside-float-warp {
  position: fixed;
  right: 0;
  top: 50%;
  height: 311px;
  margin-top: -76px;
  list-style: none;
  z-index: 99;
  width: 96.4px;
  background: url("~_img/coursecardimg/asidebg.png") no-repeat;
  box-sizing: border-box;
  .aside-float {
    width: 91px;
    height: 203px;
    background: #FFFFFF;
    border-radius: 4px;
    margin: 0 auto;
    margin-top: 105px;
    padding-top: 9px;
    box-sizing: border-box;
    li {
      box-sizing: border-box;
      width: 80px;
      height: 30px;
      border: 2px solid #DF2727;
      border-radius: 4px;
      font-size: 14px;
      font-family: FZLanTingHei-R-GBK;
      font-weight: 400;
      color: #000000;
      line-height: 26px;
      text-align: center;
      margin: 0 auto;
      margin-bottom: 9px;
    }
    li:hover {
       cursor: pointer;
       color: #FFFFFF;
       background: #DF2727;
    }
    .tel {
      position: relative;
      .tel-img {
        display: none;
        position: absolute;
        left: -237px;
        top: -6px;
        width: 229px;
        height: 43px;
        background:url("~_img/coursecardimg/telbg.png") no-repeat;
      }
    }
    .tel:hover {
      .tel-img {
        display: block;
      }
    }
  }
}
</style>
